import { connect } from 'react-redux';
import ConcessionModal from './ConcessionModal.component';

const mapStateToProps = () => ({

});

export default connect(mapStateToProps)(ConcessionModal);

